module.exports = __webpack_public_path__ + "img/g9.4cada6ac.jpg";